<template>
    <div class="col-md-12">
        <div class="h2">Invoices</div>
        <div class="flash-message">
            <FlashMessage :position="'top'"></FlashMessage>
        </div>
        <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
            <li class="nav-item" role="presentation">
                <button
                    class="nav-link"
                    :class="{ active: activeTab === 'tab1' }"
                    @click="changeTab('tab1')"
                    role="tab"
                >
                    Overview
                </button>
            </li>
            <li class="nav-item" role="presentation">
                <button
                    class="nav-link"
                    :class="{ active: activeTab === 'tab2' }"
                    @click="changeTab('tab2')"
                    role="tab"
                >
                    Booking
                </button>
            </li>
            <li class="nav-item" role="presentation">
                <button
                    class="nav-link"
                    :class="{ active: activeTab === 'tab3' }"
                    @click="changeTab('tab3')"
                    role="tab"
                >
                    Created invoices
                </button>
            </li>
        </ul>

        <div class="form-container">
            <div class="datetime">
                <date-picker v-model="filters.month"
                             valueType="MM"
                             type="month"
                             placeholder="Month"
                             input-class="border-0 py-0 shadow-none form-input"
                             @input="getClientsWithoutInvoices"
                             format="MM">
                </date-picker>
            </div>
            <div class="datetime">
                <date-picker v-model="filters.year"
                             valueType="YYYY"
                             type="year"
                             placeholder="Year"
                             input-class="border-0 py-0 shadow-none form-input"
                             @input="getClientsWithoutInvoices"
                             format="YYYY">
                </date-picker>
            </div>
            <div class="datetime">
                <input @change="getClientsWithoutInvoices"
                       v-model="filters.week"
                       class="form-control"
                       type="number"
                       min="0"
                       step="1"
                       placeholder="week">
            </div>
            <div>
                <v-select
                    v-if="activeTab === 'tab2'"
                    :options="clientList"
                    v-model="filters.client"
                    clearOnSelect="false"
                    label="name"
                    id="client-name"
                    @input="getClientsWithoutInvoicesDetailed"
                >
                </v-select>
            </div>
            <div class="save-button">
                <button v-if="activeTab === 'tab2'" class="btn btn-primary" @click="createInvoices()">Book invoice
                </button>
            </div>
        </div>

        <div class="tab-content" id="pills-tabContent">
            <div
                class="tab-pane fade"
                :class="{ 'show active': activeTab === 'tab1' }"
                id="tab1"
                role="tabpanel"
            >
                <table class="table table-bordered table-striped">
                    <thead>
                    <tr>
                        <th @click="sortClient('client_name')">Client</th>
                        <th @click="sortClient('amount')">Amount</th>
                        <th @click="sortClient('total_booking_sum')">Value</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="client in clientsWithoutInvoices">
                        <td>
                            <div @click="setClientData(client.client_id, client.client_name)">
                                <a href="#" @click="preventDefault"> <b>{{ client.client_name }}</b></a>
                            </div>
                        </td>
                        <td>{{ client.amount }}</td>
                        <td>{{ client.total_booking_sum.toLocaleString('da-DK') }}</td>
                    </tr>
                    <tr>
                        <td><b> Total: </b></td>
                        <td></td>
                        <td><b> {{ clientsWithoutInvoicesTotalSum.toLocaleString('da-DK') }} </b></td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div
                class="tab-pane fade"
                :class="{ 'show active': activeTab === 'tab2' }"
                id="tab2"
                role="tabpanel"
            >
                <table class="table table-bordered">
                    <thead>
                    <tr>
                        <th @click="sortDetailed('id')">Booking</th>
                        <th @click="sortDetailed('dropoff_end')">Date</th>
                        <th @click="sortDetailed('dropoff_end')">Week</th>
                        <th @click="sortDetailed('status_id')">Status</th>
                        <th @click="sortDetailed('total_price')">Total Price</th>
                        <th>Client Price</th>
                        <th>Customer Price</th>
                        <th>Select</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="booking in clientsWithoutInvoicesDetailed">
                        <td>
                            <a :href="`/bookings/${booking.id}/edit`"> <b>#B-{{ booking.id }}</b></a>
                        </td>
                        <td>{{ formatDate(booking.dropoff_date) }} {{ booking.dropoff_end ? booking.dropoff_end : '00:00' }}</td>
                        <td>{{ getWeek(booking.dropoff_date) }}</td>
                        <td>{{ booking.status }}</td>
                        <td>{{ booking.total_price }}</td>
                        <td>{{ booking.clientPrice }}</td>
                        <td>{{ booking.customerPrice }}</td>
                        <td><input type="checkbox" v-model="selectedBookings[booking.id]"></td>
                    </tr>
                    <tr>
                        <td colspan="7"></td>
                        <td>
                            <div v-if="!isSelectedAll">
                                <button class="btn btn-primary" @click="selectAll()">Select all
                                </button>
                            </div>
                            <div v-else>
                                <button class="btn btn-primary" @click="deSelectAll()">Remove selection
                                </button>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div
                class="tab-pane fade"
                :class="{ 'show active': activeTab === 'tab3' }"
                id="tab3"
                role="tabpanel"
            >
                <table class="table table-bordered">
                    <thead>
                    <tr>
                        <th @click="sortDetailed('id')">Booking</th>
                        <th @click="sortDetailed('dropoff_end')">Date</th>
                        <th @click="sortDetailed('dropoff_end')">Week</th>
                        <th @click="sortDetailed('status_id')">Status</th>
                        <th @click="sortDetailed('total_price')">Price</th>
                        <th>Select</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="invoice in createdInvoices">

                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>

import dateTimeMixin from "../mixins/dateTimeMixin";
export default {
    name: "Invoices",
    mixins: [dateTimeMixin],
    data() {
        return {
            activeTab: "tab1",
            clientList: [],
            clientsWithoutInvoices: {},
            clientsWithoutInvoicesDetailed: {},
            selectedBookings: {},
            clientsWithoutInvoicesTotalSum: 0,
            filters: {
                month: '09',
                year: '2023',
                week: null,
                client: {id: 1},
                sortClientColumn: 'client_name',
                sortClientDir: 'asc',
                sortDetailedColumn: 'id',
                sortDetailedDir: 'asc',
            },
            isSelectedAll: false,
            createdInvoices: {}
        }
    },
    methods: {
        sortDetailed(key) {
            if (key) {
                this.filters.sortDetailedColumn = key;
                this.filters.sortDetailedDir = this.filters.sortDetailedDir === 'asc' ? 'desc' : 'asc';
            }
            this.getClientsWithoutInvoices()
        },
        sortClient(key) {
            if (key) {
                this.filters.sortClientColumn = key;
                this.filters.sortClientDir = this.filters.sortClientDir === 'asc' ? 'desc' : 'asc';
            }
            this.getClientsWithoutInvoices()
        },
        changeTab(tabId) {
            this.activeTab = tabId;
        },
        fetchData() {
            axios.get('/client-list', {params: {noRelatedData: 1}})
                .then(({data}) => {
                    Object.entries(data.data).forEach(entry => {
                        const [key, value] = entry;
                        this.clientList.push({
                            id: value.id,
                            name: value.name,
                        });
                    });
                });
            this.getClientsWithoutInvoices();
        },
        getClientsWithoutInvoices() {
            axios.post('/clients-without-invoices', this.filters)
                .then(({data}) => {
                    this.clientsWithoutInvoices = data.data.data
                    this.clientsWithoutInvoicesTotalSum = 0;
                    for (let i = 0; i < data.data.data.length; i++) {
                        this.clientsWithoutInvoicesTotalSum += data.data.data[i].total_booking_sum;
                    }
                });
        },
        getClientsWithoutInvoicesDetailed() {
            axios.post('/clients-without-invoices-detailed', this.filters)
                .then(({data}) => {
                    this.clientsWithoutInvoicesDetailed = data.data.data
                }).catch((error) => {
                console.log(error)
            });
        },
        setClientData(id, name) {
            this.filters.client = {
                id: id,
                name: name,
            }
            this.getClientsWithoutInvoicesDetailed();
            this.activeTab = 'tab2';
        },
        selectAll() {
            this.clientsWithoutInvoicesDetailed.forEach(booking => {
                this.$set(this.selectedBookings, booking.id, true);
            });
            this.isSelectedAll = true;
        },
        deSelectAll() {
            this.selectedBookings = {}
            this.isSelectedAll = false;
        },
        createInvoices() {
            axios.post('/create-invoice', this.selectedBookings)
                .then(({data}) => {
                    this.flashMessage.success({
                        title: '',
                        message: 'Invoices successfully created',
                        time: 2000,
                        blockClass: 'flash-message'
                    });
                    setTimeout(() => {
                        window.location.reload();
                    }, 2000);
                }).catch((error) => {
                console.log(error)
            });
        },
        getWeek(day) {
            const date = new Date(day);
            return this.calculateWeekNumber(date);
        },
        calculateWeekNumber(date) {
            const startOfYear = new Date(date.getUTCFullYear(), 0, 1);
            const daysDifference = Math.floor(
                (date - startOfYear) / (24 * 60 * 60 * 1000)
            );
            const weekNumber = Math.ceil((daysDifference + 1) / 7);

            return weekNumber;
        },
        preventDefault(event) {
            event.preventDefault();
        },
    },
    created() {
        return this.fetchData()
    },
}
</script>

<style scoped>
.nav-link {
    border: 1px solid black;
}

.form-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.form-container label {
    margin-right: 10px;
}

.form-container .datetime,
.form-container select {
    margin-right: 10px;
}

.form-container .save-button {
    margin-left: auto;
}
#client-name {
    min-width: 200px;
}
</style>
